import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const REDUCED =
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Intro di caricamento: schermo #0A0A0B, il logo RINOVA emerge con un rivelo
// verticale (mask che sale) e il tracking che si chiude; una barra sottile
// #C6F24E si riempie da sinistra, poi l'overlay esce verso l'alto.
// Rispetta prefers-reduced-motion (solo fade). Nessuno spinner o rotazione.
export function IntroLoader() {
  const [show, setShow] = useState(() => {
    try {
      return !sessionStorage.getItem("rinova_intro_shown");
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (!show) return;
    try {
      sessionStorage.setItem("rinova_intro_shown", "1");
    } catch {
      /* no-op */
    }
    const t = setTimeout(() => setShow(false), REDUCED ? 480 : 1150);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[400] flex flex-col items-center justify-center bg-ink"
          initial={{ y: 0 }}
          exit={REDUCED ? { opacity: 0 } : { y: "-100%" }}
          transition={{ duration: REDUCED ? 0.3 : 0.5, ease: [0.7, 0, 0.84, 0] }}
          aria-hidden="true"
          data-testid="intro-loader"
        >
          {REDUCED ? (
            <span className="font-display text-4xl font-extrabold tracking-tight text-foreground">
              RINOVA
            </span>
          ) : (
            <>
              {/* Logo: rivelo verticale (mask che sale) + tracking che si chiude */}
              <div className="overflow-hidden">
                <motion.span
                  className="block font-display text-4xl font-extrabold text-foreground sm:text-5xl"
                  initial={{ y: "110%", letterSpacing: "0.42em", opacity: 0.2 }}
                  animate={{ y: "0%", letterSpacing: "0.01em", opacity: 1 }}
                  transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                >
                  RINOVA
                </motion.span>
              </div>
              {/* Barra sottile #C6F24E che si riempie da sinistra */}
              <div className="mt-5 h-[3px] w-40 overflow-hidden rounded-full bg-white/10">
                <motion.div
                  className="h-full w-full origin-left rounded-full bg-lime"
                  initial={{ scaleX: 0 }}
                  animate={{ scaleX: 1 }}
                  transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
                />
              </div>
            </>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
